import React, { useState } from "react";

import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from "reactstrap";

const CloneStatus = {
  Waiting: "Waiting",
  Cloning: "Cloning",
  Error: "Error",
};

const ModalClone = ({ open, toggle, item, clone }) => {
  const [alert, setAlert] = useState(false);
  const [status, setStatus] = useState(CloneStatus.Waiting);

  const handleConfirm = () => {
    let cloneResult = { success: false };
    setStatus(CloneStatus.Cloning);
    clone({ id: item.AssetId })
      .then(({ result, newId }) => {
        if (result.Code == 200) {
          cloneResult = { success: true, newId };
        } else {
          setStatus(CloneStatus.Error);
          setAlert(result.Description);
        }
        return cloneResult;
      })
      .catch((e) => {
        setStatus(CloneStatus.Error);
        setAlert(e.message);
        return cloneResult;
      });
  };
  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Asset clone confirmation</ModalHeader>
      <ModalBody>
        {status === CloneStatus.Error && <Alert color="danger">{alert}</Alert>}
        <p>
          Are you sure you want to clone{" "}
          <b>
            {item.AssetISIN}
            {" - "}
            {item.AssetTicker}
          </b>
          ?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={() => toggle()}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={status === CloneStatus.Cloning}
          onClick={handleConfirm}
          data-style={SLIDE_LEFT}
        >
          Confirm
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export default ModalClone;
